import React, { memo } from 'react';

import { func, object } from 'prop-types';

import SnackBar from '../SnackBar';

function GlobalSnackbar({ feedbackRequest, feedback }) {
  const handleClose = () => {
    feedbackRequest({ open: false });
  };

  return <SnackBar onClose={handleClose} {...feedback} />;
}

GlobalSnackbar.propTypes = {
  feedbackRequest: func,
  feedback: object,
};

export default memo(GlobalSnackbar);
